import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './_components/components.module';
import { ModalsModule } from './_modals/modals.module';
import { SharedModule } from './_shared/shared.module';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
    	BrowserAnimationsModule, // enable animations
		BrowserModule,
		ComponentsModule,
		SharedModule,
		FormsModule,
		AppRoutingModule,
		HttpClientModule,
		NgbModule,
		ModalsModule,
		MatDialogModule,
		FontAwesomeModule,
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
